import { render, staticRenderFns } from "./historicoAtendimento.vue?vue&type=template&id=aa2197ca"
import script from "./historicoAtendimento.ts?vue&type=script&lang=js&external"
export * from "./historicoAtendimento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa2197ca')) {
      api.createRecord('aa2197ca', component.options)
    } else {
      api.reload('aa2197ca', component.options)
    }
    module.hot.accept("./historicoAtendimento.vue?vue&type=template&id=aa2197ca", function () {
      api.rerender('aa2197ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/atendimento/historicoAtendimento/historicoAtendimento.vue"
export default component.exports